import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { PasswordInputComponent } from '../../inputs/password-input/password-input.component';
import { FormErrorComponent } from '../../form-error/form-error.component';

@Component({
  selector: 'lib-password-form-field',
  imports: [PasswordInputComponent, FormErrorComponent, ReactiveFormsModule],
  templateUrl: './password-form-field.component.html',
  styleUrl: './password-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  autocomplete = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  toggleDefaultVisibility = input<boolean>(false);
  inputMode = input<'text' | 'numeric' | 'decimal' | 'tel' | 'search' | 'email' | 'url'>('text');
  inputId: string = uuidv4();
}
